// ABOUTME: SPEC-82 — the tap-to-talk gate as a pure state machine: idle -> holding -> released.
// ABOUTME: One terminal state per page load; a second arm after a release is ignored.

export const GATE = Object.freeze({ IDLE: 'idle', HOLDING: 'holding', RELEASED: 'released' });
export const GATE_EVENT = Object.freeze({ ARM: 'arm', RELEASE: 'release' });

/**
 * @param {string} state one of GATE
 * @param {string} event one of GATE_EVENT
 * @returns {string} the next state; unknown events and illegal transitions return `state` unchanged
 */
export function gateReducer(state, event) {
  if (event === GATE_EVENT.ARM && state === GATE.IDLE) return GATE.HOLDING;
  if (event === GATE_EVENT.RELEASE && state === GATE.HOLDING) return GATE.RELEASED;
  return state;
}
